module.exports = __webpack_public_path__ + "images/root/mainVisual_products_left_pc_7e6ab8a71b572e3f22a1ab49a28d413d.svg";